<template>
  <section>
    <drivers-header title="Профиль" />
    <div class="driver flex-column-between">
      <div>
        <div class="driver__title">Организация</div>
        <div class="driver__description">
          Указанная при регистрации аккаунта
        </div>
        <div class="driver__content">
          <div
            class="profile__confirm flex-v-center"
            :class="isOrgConfirmed ? 'accept' : 'waiting'"
          >
            <div
              class="profile__confirm-icon"
              :class="isOrgConfirmed ? 'icon-accept' : 'icon-waiting'"
            />
            <div class="profile__confirm-text">
              {{
                isOrgConfirmed
                  ? 'Организация подтверждена диспетчером'
                  : 'Организация на рассмотрении у диспетчера'
              }}
            </div>
          </div>
          <div class="profile">
            <div class="profile__info flex-column-between">
              <div class="font-normal">Организация (название ИП)</div>
              <div class="profile__info-title">
                {{ curOrgShortName }}
              </div>
            </div>
          </div>
          <div class="profile flex-v-center">
            <div class="profile__info flex-column-between">
              <div class="font-normal">ИНН</div>
              <div class="profile__info-title">
                {{ cur_org_inn }}
              </div>
            </div>
          </div>
          <!--          договор планировался как кнопка с возможностью скачивания-->
          <!--          поскольку вероятно, что эту фнукцию потом придется делать,-->
          <!--          оставляю комментами изменения, чтобы вернуть легко-->
          <!--          <div v-if="hasContract" class="profile mod_button flex-v-center" @click="loadContract">-->
          <div v-if="hasContract" class="profile flex-v-center">
            <!--            <div class="profile__picture flex-center">-->
            <!--              <img src="@/assets/img/new-soft-disk.svg" alt="softdisk">-->
            <!--            </div>-->
            <div class="profile__info flex-column-between">
              <div class="profile__info-title">
                Договор {{ contractData.number }}
              </div>
              <div class="font-normal">от {{ contractData.date }}</div>
            </div>
            <!--            <div class="profile__download">-->
            <!--              <img src="@/assets/img/new-download.svg" alt="download">-->
            <!--            </div>-->
          </div>
        </div>
      </div>
      <div class="profile__logout" @click="isLogoutOpen = true">
        Выход из аккаунта
      </div>
    </div>
    <el-dialog
      :visible.sync="isLogoutOpen"
      width="100%"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      class="logout__confirmation"
    >
      <div class="logout__confirmation-title">
        Вы уверены что хотите <br />
        выйти из профиля?
      </div>
      <span
        slot="footer"
        class="logout__confirmation-footer flex-between-center"
      >
        <new-button
          title="Отмена"
          type="gray"
          width="fullWidth"
          class="logout__button"
          @button-clicked="isLogoutOpen = false"
        />
        <new-button
          title="Выйти"
          type="primary"
          width="fullWidth"
          class="logout__button"
          @button-clicked="logout"
        />
      </span>
    </el-dialog>
  </section>
</template>

<script>
import { mapActions } from 'vuex'
import DriversHeader from '@/components/Drivers/DriversHeader/DriversHeader'
import NewButton from '@/components/Drivers/NewButton/NewButton'
export default {
  name: 'ProfileMobile',
  components: {
    DriversHeader,
    NewButton,
  },
  data() {
    return {
      isLogoutOpen: false,
    }
  },
  computed: {
    isOrgConfirmed() {
      if (this.userInfo && this.userInfo.profile) {
        return this.userInfo.profile.organization_approved
      }

      return false
    },
    hasContract() {
      return Boolean(
        this.userInfo &&
          this.userInfo.profile &&
          this.userInfo.profile.organization_contract &&
          this.userInfo.profile.organization_contract.length,
      )
    },
    contractData() {
      if (this.hasContract) {
        const data = this.userInfo.profile.organization_contract.split('от')

        return {
          number: data[0].trim(),
          date: data[1].trim(),
        }
      }

      return null
    },
  },
  methods: {
    ...mapActions({
      logout: 'auth/authLogout',
    }),
    // loadContract() {
    //   console.log('Скачать договор, когда понадобится')
    // },
  },
}
</script>

<style lang="sass" scoped>
@import "@/assets/styles/driver-styles.sass"
.profile
  margin-bottom: 1.2rem
  padding: 1.6rem
  border: 1px solid #EDEDED
  border-radius: 1.2rem
  cursor: pointer
  /*&.mod-button*/
  /*  position: relative*/
  /*  margin-top: 2rem*/
  /*  margin-bottom: 4.5rem*/
  /*  border: none*/
  /*  box-shadow: 0 0 10px rgba(132, 132, 132, 0.15)*/
  &__info-title
    font-size: 1.6rem
    line-height: 2rem
    font-weight: 700
    color: #181818
  &__picture
    width: 4.6rem
    height: 4.6rem
    margin-right: 1.6rem
    background: #EBF9EB
    border-radius: .8rem
    img
      width: 2.4rem
      height: 2.4rem
  &__button
    width: 100%
    height: 5.2rem
    padding: 0
    font-size: 1.6rem
    font-weight: 800
    border-radius: 0.8rem
    background: $mainColor
    color: #FFFFFF
    cursor: pointer
    &:hover
      background: #00833C
    &:active
      background: #006421
    img
      width: 2.4rem
      height: 2.4rem
      margin-right: 0.8rem
  /*&__download*/
  /*  position: absolute*/
  /*  top: 1.6rem*/
  /*  right: 1.6rem*/
  /*  width: 2.4rem*/
  /*  height: 2.4rem*/
  &__confirm
    height: 3.6rem
    margin-bottom: 2rem
    padding: 0 1.2rem
    border-radius: .8rem
    font-weight: 400
    font-size: 12px
    line-height: 16px
    color: #181818
    &.accept
      background: #E6FFE2
    &.waiting
      background: #FFECE1

    &-icon
      width: 2.4rem
      height: 2.4rem
      margin-right: .6rem
      background-size: cover
      &.icon-accept
        background: url('~@/assets/img/new-accept.svg')
      &.icon-waiting
        background: url('~@/assets/img/new-waiting.svg')

  &__logout
    margin-bottom: 3.8rem
    text-align: center
    font-weight: 800
    font-size: 1.6rem
    line-height: 2.4rem
    color: #8B8B8B
    cursor: pointer

.logout__confirmation
  display: flex
  align-items: center
  .logout__confirmation-title
    text-align: center
    font-weight: 800
    font-size: 2rem
    line-height: 2.8rem
    color: #181818
  &-footer
    width: 100%
    .logout__button
      width: 48%

::v-deep .el-dialog
  margin: 0 1.6rem !important
  border-radius: 12px !important
  &__header
    display: none
  &__body
    padding: 3.2rem 2.4rem
  &__footer
    justify-content: space-between
    padding: 0 1.6rem 2rem
    border-top: none
    button
      margin-top: 0
::v-deep .v-modal
  background: #2B2B2B
  opacity: .7
</style>
